import { Button } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import env from '@/env';
import { useAtomValue } from 'jotai';
import { patchUserNavOverridesAtom } from '@/atoms/mutations/user/user';
import { userNavOverridesAtom } from '@/atoms/queries/user';
import { KeysToCamelCase } from '@/types/generic';
import { UserNavOverrides } from '@statsbomb/parachute-types';
import { ErrorBoundary } from '@sentry/react';
import { Suspense } from 'react';
import { useShouldShowHybridNav } from '@/hooks/navigation/useShouldShowHybridNav';

interface SwitchToClassicButtonProps {
  path: string;
  navOverrides: Partial<{ [key in keyof KeysToCamelCase<UserNavOverrides>]: boolean | undefined }>;
}

const SwitchToClassicButtonBase = ({ isShowing, onClick }: { isShowing: boolean; onClick?: () => void }) => {
  const { t } = useTranslation('experience');

  return (
    isShowing && (
      <Button size="small" variant="primary" onClick={onClick} isPending={!onClick}>
        {t('switchToClassicButton')}
      </Button>
    )
  );
};

const SwitchToClassicButtonWithData = ({ navOverrides, path }: SwitchToClassicButtonProps) => {
  const shouldShowHybridNav = useShouldShowHybridNav();

  const userNavOverrides = useAtomValue(userNavOverridesAtom);
  const { mutateAsync: patchUserNavOverrides } = useAtomValue(patchUserNavOverridesAtom);

  const onClick = async () => {
    await patchUserNavOverrides({
      ...userNavOverrides,
      ...navOverrides,
    });
    window.location.href = `https://${env.VITE_IQ_DOMAIN}/${path}`;
  };

  return <SwitchToClassicButtonBase onClick={onClick} isShowing={shouldShowHybridNav} />;
};

export const SwitchToClassicButton = (props: SwitchToClassicButtonProps) => (
  <ErrorBoundary fallback={<SwitchToClassicButtonBase isShowing={false} />}>
    <Suspense fallback={<SwitchToClassicButtonBase isShowing={false} />}>
      <SwitchToClassicButtonWithData {...props} />
    </Suspense>
  </ErrorBoundary>
);
